import { NotificationManager } from "react-notifications";
import { checkExecutionStatus } from "@/components/common/helpers/RequestHelpers";

import apiURL from "./apiURL";
import axios from "axios";

import { createRequest } from "@/components/common/helpers/RequestHelpers";

const adminRequest = createRequest({
	urlPath: "/settings/admin",
	// local: true,
});

const pdfRequest = createRequest({
	urlPath: "/settings/pdf",
});

const Types = {
	ADMIN_GET_USER_MODAL: "ADMIN_GET_USER_MODAL",
	ADMIN_GET_USER: "ADMIN_GET_USER",
	ADMIN_GET_CERTIFICATE_MODAL: "ADMIN_GET_CERTIFICATE_MODAL",
	ADMIN_UPDATE_ACCOUNT_STATUS: "ADMIN_UPDATE_ACCOUNT_STATUS",
	ADMIN_REMOVE_SAVED_PAYMENT_HANDLE: "ADMIN_REMOVE_SAVED_PAYMENT_HANDLE",
	ADMIN_SET_PAYMENT_HANDLES: "ADMIN_SET_PAYMENT_HANDLES",
	ADMIN_GET_PAYMENT_HANDLE_MODAL: "ADMIN_GET_PAYMENT_HANDLE_MODAL",
	ADMIN_GET_CREATE_NOTIFICATION_MODAL: "ADMIN_GET_CREATE_NOTIFICATION_MODAL",
	ADMIN_UPDATE_NOTIFICATIONS: "ADMIN_UPDATE_NOTIFICATIONS",
	ADMIN_GET_BILLING_EMAILS: "ADMIN_GET_BILLING_EMAILS",
};

const updateGetUserState = (payload) => ({
	type: Types.ADMIN_GET_USER,
	payload,
});

const getUserModal = (toggle) => ({
	type: Types.ADMIN_GET_USER_MODAL,
	toggle,
});

const getCertificateModal = (toggle) => ({
	type: Types.ADMIN_GET_CERTIFICATE_MODAL,
	toggle,
});

const adminGetUser = (input) => {
	return (dispatch, getState) => {
		console.debug(input);

		if (!input?.replace(/\s/g, "")) {
			NotificationManager.error("User cannot be empty", "Getting User Information");
			return;
		}

		const query = input.includes("@") ? { email: input } : { input };

		adminRequest({
			method: "GET",
			path: `/user`,
			query,
		})
			.then((res) => {
				if (res.data.error) {
					NotificationManager.error(res.data.error, "Getting User Information");
					dispatch(updateGetUserState());
					return;
				}
				dispatch(updateGetUserState(res.data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("There was an error getting this user", "Getting User Information");
			});
	};
};

const sendCertificates = (data) => {
	return async (dispatch, getState) => {
		let arn;

		await pdfRequest({
			method: "POST",
			path: `/CourseCertificates`,
			body: data,
		})
			.then(({ data }) => {
				NotificationManager.success("Certificates Saved, attemping download...", "Saving Certificates");
				arn = data.executionArn;
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error saving certificates", "Saving Certificates");
			});

		if (arn) {
			await checkExecutionStatus(arn)
				.then((body) => {
					NotificationManager.success("Certificates downloaded successfully", "Saving Certificates");
					const data = body.output;

					for (const certificate in data) {
						const popup = window.open(data[certificate].url);
						if (!popup || popup.closed || typeof popup.closed == "undefined") {
							//Worked For IE and Firefox
							alert("Popup Blocker is enabled! Please add this site to your exception list.");
						}
					}
				})
				.catch((error) => {
					NotificationManager.error("Failed to download certificates", "Saving Certificates");
				});
		}
	};
};

const updateAccountStatus = (payload) => ({
	type: Types.ADMIN_UPDATE_ACCOUNT_STATUS,
	payload,
});

const deferSuspendedAccount = (payload) => {
	return (dispatch, getState) => {
		console.debug(payload);

		fetch(apiURL + `/settings/admin/deferSuspendedAccount`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				payload,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((res) => {
				if (res.data.error) {
					NotificationManager.error(res.data.error, "Defering Account");
					return;
				}
				NotificationManager.success("Account successfully deferred", "Defering Account");
				dispatch(updateAccountStatus("temporary active"));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("There was an error defering this account", "Defering Account");
			});
	};
};

const removeSavedPaymentHandle = (payload) => ({
	type: Types.ADMIN_REMOVE_SAVED_PAYMENT_HANDLE,
	payload,
});

const savePaymentHandleStatus = ({ id, org, advisor }) => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/admin/bankPayments`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				id,
				org,
				advisor,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((res) => {
				if (res.error) {
					NotificationManager.error(res.error, "Payment Handle");
					return;
				}
				NotificationManager.success("Payment Successfully Handled", "Payment Handle");
				dispatch(getPaymentHandleModal(false));
				dispatch(removeSavedPaymentHandle(id));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("There was an error handling this payment", "Payment Handle");
			});
	};
};

const setPaymentHandles = (payload) => ({
	type: Types.ADMIN_SET_PAYMENT_HANDLES,
	payload,
});

const getPaymentHandle = () => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/admin/bankPayments`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => dispatch(setPaymentHandles(data.bankPayments)))
			.catch((error) => {
				console.error(error);
				NotificationManager.error("There was an error getting payment handles", "Getting Payment Handles");
			});
	};
};

const getPaymentHandleModal = (payload) => ({
	type: Types.ADMIN_GET_PAYMENT_HANDLE_MODAL,
	payload,
});

const getCreateNotificationModal = (status, notificationId) => ({
	type: Types.ADMIN_GET_CREATE_NOTIFICATION_MODAL,
	status,
	notificationId,
});

const updateNotifications = (payload) => ({
	type: Types.ADMIN_UPDATE_NOTIFICATIONS,
	payload,
});

const getNotifications = () => {
	return (dispatch, getState) => {
		adminRequest({
			method: "GET",
			path: `/globalNotifications`,
		})
			.then((res) => {
				if (res.data.error) {
					NotificationManager.error(res.data.error, "Getting Notifications");
					return;
				}
				dispatch(updateNotifications(res.data.notifications));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("There was an error getting notifications", "Getting Notifications");
			});
	};
};

const saveNotification = (data) => {
	return (dispatch, getState) => {
		adminRequest({
			method: "POST",
			path: `/globalNotifications`,
			body: data,
		})
			.then((res) => {
				if (res.data.error) {
					NotificationManager.error(res.data.error, "Saving Notification");
					return;
				}
				NotificationManager.success("Notification successfully saved", "Saving Notification");
				dispatch(getNotifications());
				dispatch(getCreateNotificationModal());
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("There was an error saving this notification", "Saving Notification");
			});
	};
};

const getBillingEmails = () => {
	return (dispatch, getState) => {
		adminRequest({
			method: "GET",
			path: `/billingEmails`,
		})
			.then((res) => {
				if (res.data.error) {
					NotificationManager.error(res.data.error, "Getting Billing Emails");
					return;
				}
				dispatch(loadedBillingEmails(res.data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("There was an error getting billing emails", "Getting Billing Emails");
			});
	};
};

const loadedBillingEmails = (payload) => ({
	type: Types.ADMIN_GET_BILLING_EMAILS,
	payload,
});

const Actions = {
	adminGetUser,
	getUserModal,
	deferSuspendedAccount,
	getCertificateModal,
	sendCertificates,
	savePaymentHandleStatus,
	getPaymentHandle,
	getPaymentHandleModal,
	getCreateNotificationModal,
	getNotifications,
	saveNotification,
	getBillingEmails,
};

export { Actions, Types };
